import "./axios-provider.js";
import { jsx } from "react/jsx-runtime";
import { createContext, useState, useMemo, useContext } from "react";
import { formatISO } from "date-fns";
import { useAppointments } from "../hooks/useAppointments.js";
import "axios";
import "@tanstack/react-query";
import "../helpers/common.js";
import "date-fns/locale";
import "../appointment-details.types.js";
const AppointmentsContext = createContext({ queryKey: null, data: [], queryResult: {}, setDuration: () => {
} });
const AppointmentsProvider = ({
  children,
  auth,
  clinicReferenceId,
  appointmentReferenceId,
  employeeReferenceId = ""
}) => {
  const [[startAfter, startBefore], setDuration] = useState([null, null]);
  const params = useMemo(
    () => ({
      employeeReferenceIds: [employeeReferenceId],
      startAfter: formatISO(startAfter ?? /* @__PURE__ */ new Date()),
      startBefore: formatISO(startBefore ?? /* @__PURE__ */ new Date()),
      showCancelled: false,
      clinicReferenceId
    }),
    [employeeReferenceId, auth, clinicReferenceId, startAfter, startBefore]
  );
  const disabled = !startAfter || !startBefore || !!appointmentReferenceId || !employeeReferenceId;
  const { data = [], queryKey, queryResult } = useAppointments({ clinicReferenceId, auth, params, disabled });
  const value = useMemo(
    () => ({
      data,
      queryKey,
      queryResult,
      setDuration
    }),
    [queryKey, data, queryResult]
  );
  return /* @__PURE__ */ jsx(AppointmentsContext.Provider, { value, children });
};
const useAppointmentsProvider = () => {
  const context = useContext(AppointmentsContext);
  if (context === void 0) {
    throw new Error("useAppointmentsProvider must be used within a AppointmentsProvider");
  }
  return context;
};
export {
  AppointmentsProvider,
  useAppointmentsProvider
};
